import { registerChatArtifactPreviewComponent } from '@oui/app-core/src/components/ChatArtifactPreview';
import { registerChatInputArtifactHandler } from '@oui/app-core/src/components/ChatInputArtifact';

import { WordPairingIndex } from './screens';

registerChatArtifactPreviewComponent('WordPairing', () => WordPairingIndex);
registerChatInputArtifactHandler('WordPairing', async ({ navigate, startArtifactRequest }) => {
  startArtifactRequest('WordPairing');
  navigate('WordPairingIndex', {});
});

export * from './screens';
export * from './components';
export * from './hooks';
export * from './types/navigation';
export * from './register';
